import capitalize from '../utils/capitalize';
import lowercase from '../utils/lowercase';
export var Lifecycle;
(function (Lifecycle) {
    Lifecycle["load"] = "load";
    Lifecycle["show"] = "show";
    Lifecycle["hide"] = "hide";
    Lifecycle["ready"] = "ready";
    Lifecycle["pullDownRefresh"] = "pullDownRefresh";
    Lifecycle["reachBottom"] = "reachBottom";
    Lifecycle["pageScroll"] = "pageScroll";
    Lifecycle["shareAppMessage"] = "shareAppMessage";
    Lifecycle["shareTimeline"] = "shareTimeline";
    Lifecycle["titleClick"] = "titleClick";
    Lifecycle["optionMenuClick"] = "optionMenuClick";
    Lifecycle["popMenuClick"] = "popMenuClick";
    Lifecycle["pullIntercept"] = "pullIntercept";
    Lifecycle["back"] = "back";
    Lifecycle["keyboardHeight"] = "keyboardHeight";
    Lifecycle["tabItemTap"] = "tabItemTap";
    Lifecycle["beforeTabItemTap"] = "beforeTabItemTap";
    Lifecycle["resize"] = "resize";
    Lifecycle["unload"] = "unload";
})(Lifecycle || (Lifecycle = {}));
export var AppLifecycle;
(function (AppLifecycle) {
    AppLifecycle["launch"] = "launch";
    AppLifecycle["show"] = "show";
    AppLifecycle["hide"] = "hide";
    AppLifecycle["error"] = "error";
    AppLifecycle["shareAppMessage"] = "shareAppMessage";
    AppLifecycle["pageNotFound"] = "pageNotFound";
    AppLifecycle["unhandledRejection"] = "unhandledRejection";
    AppLifecycle["themeChange"] = "themeChange";
})(AppLifecycle || (AppLifecycle = {}));
export function lifeCycleName(name) {
    if (name.startsWith('before')) {
        return name;
    }
    return lowercase(name.slice(2));
}
export function callbackName(name) {
    if (name.startsWith('before')) {
        return name;
    }
    return 'on' + capitalize(name);
}
export function registerLifecycle(instance, method, callback) {
    return instance.registerLifecycle(method, callback);
}
export * from './events';
